import { beginPageview } from "@telia/b2x-google-analytics";

import { w } from "../util";

let armed = false;

const currentKey = () => (w ? w.location.pathname + w.location.search : "");

// Strips the hash so it matches the path+search key the pageview trigger uses.
const destinationKey = (url: string) => url.split("#")[0];

// Re-arms the event queue at the start of a client-side navigation, before the
// new page's React effects run, so custom_pageview is pushed before dependent
// events. Uses the Next.js router instead of patching the History API.
export const initPageviewQueue = () => {
  const router = w?.next?.router;
  if (!router || armed) {
    return;
  }
  armed = true;

  router.events.on("routeChangeStart", (url) => {
    if (destinationKey(url) !== currentKey()) {
      beginPageview();
    }
  });
};
